import {ChangeDetectorRef, Component, NgZone, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  Loading,
  LoadingController,
  NavController,
  NavParams,
  Platform, TextInput,
  ToastController,
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {InstructionsPage} from "../instructions/instructions";
import {ReaderService} from "../../providers/reader.service";
import {VizixService} from "../../providers/vizix.service";
import {ConfigurationThing} from "../../models/configurationThing";
import {SplashPage} from "../splash/splash";
import {ReaderDevice} from "../../models/reader-model/readerDevice";
import {ReaderDeviceGroup} from "../../models/reader-model/readerDeviceGroup";
import {deserialize} from "serializer.ts/Serializer";
import {TagReadBarcodeResponse} from "../../models/reader-model/tagReadBarcodeResponse";
import {Keyboard} from "@ionic-native/keyboard";
import {
  NAV_PARAM_BACK_TO_MENU,
  NAV_PARAM_CONFIGURATION_THING,
  NAV_PARAM_CONNECTED_TO_READER,
  NAV_PARAM_RETURN_PAGE,
  NAV_PARAM_SELECTED_READER,
  STORAGE_READER_SOUND_LEVEL, VALIDATION_INPUT_DEVICE_NAME, VALIDATION_INPUT_USER,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from '../../app/app.constants';
import {AppConfigPage} from '../app-config/app-config';
import {VizixEventItem} from "../../models/VizixEventItem";
import {VizixEventService} from "../../providers/vizix.event.service";
import {LoginPage} from "../login/login";
import {Storage} from "@ionic/storage";
import {SimulatorService} from "../../providers/simulator.service";
import {Subscription} from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/timeoutWith';

/**
 * Generated class for the DeviceSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-device-select',
  templateUrl: 'device-select.html',
})
export class DeviceSelectPage {

  private tag = '[DEVICE_SELECT]';
  private onResumeSubscription: Subscription;
  devices: ReaderDeviceGroup[] = [];
  searchText: string = '';
  isDeviceBarcode: boolean = false;
  isCameraEnabled: boolean = false;
  configurationThing: ConfigurationThing;
  isKeyboardOpen: boolean = false;
  isLogoutOptionClicked: boolean;
  isAlertShowing: boolean;
  alertExitLogOut: Alert;

  backToMenu: boolean = false;
  returnPage: string;

  isDragging: boolean = false;

  private logoutTimer: any;

  @ViewChild(Content) content: Content;
  @ViewChild('inputTypeScan') inputTypeScanField: TextInput;
  private isPopActive: boolean = false;
  private loading: Loading;

  isLoading: boolean = false;
  private isConnecting: boolean = false;
  private deviceListSubscription: Subscription;
  private isIosVersionLessThan11: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public readerService: ReaderService,
              public vizixService: VizixService,
              public simulatorService: SimulatorService,
              public toastCtrl: ToastController,
              private _platform: Platform,
              private _alertCtrl: AlertController,
              private vizixEventService: VizixEventService,
              private storage: Storage,
              private cdr: ChangeDetectorRef,
              public platform: Platform,
              private _ngZone: NgZone,
              public loadingCtrl: LoadingController,
              private keyboard: Keyboard) {
    this.configurationThing = navParams.get('configurationThing');
    this.isAlertShowing = false;
    this.backToMenu = navParams.get(NAV_PARAM_BACK_TO_MENU);
    this.returnPage = this.navParams.get(NAV_PARAM_RETURN_PAGE);
    this.loading = this.initLoading();

    this.askPlatformOs();

    this.onResumeSubscription = this._platform.resume.subscribe(() => {
      this.loading = this.initLoading();
      this.devices = [];
      this.getAvailableDeviceList();
    });
  }

  //Ask OS and Ios version
  askPlatformOs() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.isIosVersionLessThan11 = false;
      } else if (this.platform.is('ios')) {
        const osVersionNumber = this.platform.version().num;
        this.isIosVersionLessThan11 = osVersionNumber < 11;
      } else if (this.platform.is('mobileweb')) {
        this.isIosVersionLessThan11 = false;
      } else {
        this.isIosVersionLessThan11 = false;
      }
    });
  }

  /**
   * Get available device list through reader service
   */
  getAvailableDeviceList() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.devices = [];
      this.loading.present();
      this.deviceListSubscription = this.readerService.availableDeviceList()
        .subscribe(
          (result: Array<ReaderDevice>) => {
            if (this.loading) {
              this.loading.dismiss().then(() => this.loading = null);
            }

            this.isLoading = false;
            console.log(this.tag, 'ListAvailableDevices: ', result);

            // TODO: UNCOMMENT FOR NEXT VERSION
            // if(this.simulatorService.isSimulatorEnabled){
            //   result.push(new ReaderDevice(SIMULATOR_READER_ADDRESS, SIMULATOR_READER_NAME, SIMULATOR_READER_TYPE));
            // }
            //Delete content from main array
            this.devices = [];
            if (result && result.length > 0) {
              if (this.loading)
                this.loading.dismiss().then(() => this.loading = null);
              for (let device of result) {
                let deserializedDevice = deserialize<ReaderDevice>(ReaderDevice, device);
                console.log(this.tag, 'Deserialized device: ', deserializedDevice);
                if (deserializedDevice.type == 'ZEBRA') {
                  console.log(deserializedDevice);
                  let isAdded = false;
                  for (let deviceGroup of this.devices) {
                    if (deviceGroup.type == deserializedDevice.type) {
                      this._ngZone.run(() => {
                        // deserializedDevice.address;
                        //Push object to list
                        deviceGroup.deviceList.push(deserializedDevice);
                      });
                      isAdded = true;
                      break;
                    }
                  }
                  if (!isAdded) {
                    this._ngZone.run(() => {
                      this.devices.push(new ReaderDeviceGroup().fromDevice(deserializedDevice));
                    })
                  }
                }
              }
            }
            else {
              this._ngZone.run(() => {
                this.devices = [];
                this.content.resize();
              });

            }
            console.log(this.tag, this.devices);
            /*this.refreshTimer = setTimeout(() => {
              this.getAvailableDeviceList();
            }, 5000);*/
          },
          () => {
            if (this.loading) {
              this.loading.dismiss().then(() => this.loading = null);
            }
            this.isLoading = false;
            console.log(this.tag, 'error');
          }
        );
    }
  }

  unsubscribeAll() {
    if (this.deviceListSubscription) {
      this.deviceListSubscription.unsubscribe();
    }
    this.onResumeSubscription.unsubscribe();
    if (!this.returnPage) {
    }
  }

  /**
   * Check if device barcode is built-in
   */
  checkDeviceBarcode() {
    this.readerService.isDeviceBarcode().subscribe(
      (result) => {
        console.log(this.tag, result);
        if (result) {
          this.isDeviceBarcode = true;
          console.log(this.tag, 'Device is barcode enabled');
          this.readerService.initScanDeviceBarcode().subscribe(
            (result) => {
              this.processBarcode(result);
            },
            () => {
              console.log(this.tag, 'Error in device barcode initialization');
            }
          );
        } else {
          console.log(this.tag, 'Device is not barcode enabled');
        }
      },
      (error) => {
        console.log(this.tag, error);
      }
    );
  }

  ionViewDidLoad() {
    this.loading = this.initLoading();
    // this.loading.present();
    this.keyboard.onKeyboardShow().subscribe(() => {
      this.isKeyboardOpen = true;
      this.content.resize();
    });
    this.keyboard.onKeyboardHide().subscribe(() => {
      this.isKeyboardOpen = false;
      this.content.resize();
    });
    //if is Camera Enabled this will open barcode camera scan
    //this.isCameraEnabled = this._platform.is('cordova');
    this.getAvailableDeviceList();
    this.checkDeviceBarcode();
  }

  ionViewWillEnter() {
    this.isConnecting = false;
    this._platform.registerBackButtonAction(() => {
      this.goBack();
    });

    // this.cdr.reattach();
  }

  goBack() {
    if (this.backToMenu) {
      if (!this.isPopActive) {
        this.isPopActive = true;
        this.navCtrl.pop();
      }
    } else {
      this.alertExitOrLogoutConfirm();
    }
  }

  processBarcode(barcode: TagReadBarcodeResponse) {
    console.log(this.tag, 'Device barcode found');
    console.log(this.tag, barcode);

    //Reader paired
    for (let deviceGroup of this.devices) {
      for (let device of deviceGroup.deviceList) {
        if (device.name.toLowerCase().includes(barcode.value.toLowerCase())) {
          this.goToSplash(device);
          return;
        }
      }
    }

    // First sequence for pairing
    //Pair action
    this.readerService.continueWithoutReader = null;
    console.log(this.tag, "continue with reader" + this.readerService.continueWithoutReader);

    let returnNavParams = {};
    returnNavParams[NAV_PARAM_CONFIGURATION_THING] = this.configurationThing;
    returnNavParams[NAV_PARAM_SELECTED_READER] = null;
    returnNavParams[NAV_PARAM_CONNECTED_TO_READER] = barcode.value;

    this.navCtrl.popToRoot();
    this.navCtrl.push(SplashPage, returnNavParams);
  }

  clearScreen() {
    this.searchText = '';
  }

  openBarcodeCamera() {
    this.readerService.initBarcodeCameraScan().then((barcode) => {
      this.processBarcode(new TagReadBarcodeResponse(new Date().getMilliseconds(), barcode.value, "CAMERA"));
    }, (error) => {
      console.log(this.tag, 'Error barcode camera', error);
    });
  }

  goToInfo() {
    const {isDeviceBarcode} = this;
    this.navCtrl.push(InstructionsPage, {isDeviceBarcode});
  }

  goToSplash(selectedReader: ReaderDevice) {
    if (!this.isDragging && !this.isConnecting) {
      this.isConnecting = true;
      this.readerService.continueWithoutReader = selectedReader == null;
      console.log(this.tag, "continue with reader" + this.readerService.continueWithoutReader);

      let returnNavParams = {};
      returnNavParams[NAV_PARAM_CONFIGURATION_THING] = this.configurationThing;
      returnNavParams[NAV_PARAM_SELECTED_READER] = selectedReader;

      if (!this.backToMenu) {
        //First loading config, zones, connect reader
        this.navCtrl.push(SplashPage, returnNavParams);
      } else {
        if (selectedReader) {
          returnNavParams[NAV_PARAM_RETURN_PAGE] = this.returnPage;
          // New reader connected
          this.navCtrl.push(SplashPage, returnNavParams);
        } else {
          // Continue without reader = Single back action
          if (!this.isPopActive) {
            this.isPopActive = true;
            this.navCtrl.pop();
          }
        }
      }
    } else {
      this.isDragging = false;
    }
  }

  /**
   * Go to application config page
   */
  goToAppConfig() {
    this.navCtrl.push(AppConfigPage, {fromDeviceSelect: true});
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log(this.tag, 'Dismissed toast');
    });

    toast.present();
  }


  private alertExitOrLogoutConfirm() {

    if (this.alertExitLogOut) {
      this.alertExitLogOut.dismiss();
    }

    if (this._platform.is('android')) {
      this.alertExitLogOut = this._alertCtrl.create({
        title: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.title'),
        subTitle: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.message'),
        buttons: [
          {
            text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.logout'),
            handler: () => {
              console.log(this.tag, "LOGOUT");
              this.isAlertShowing = false;
              this.isLogoutOptionClicked = true;
              this.setReaderDisconnected();
            }
          },
          {
            text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.exit'),
            handler: () => {
              console.log(this.tag, "EXIT");
              this.isAlertShowing = false;
              this.isLogoutOptionClicked = false;
              this.setReaderDisconnected();
            }
          },
          {
            text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.cancel'),
            role: 'cancel',
            handler: () => {
              console.log(this.tag, 'Cancel clicked');
              this.isAlertShowing = false;
            }
          }
        ]
      });

    } else {
      this.alertExitLogOut = this._alertCtrl.create({
        title: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.title'),
        subTitle: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.message'),
        buttons: [
          {
            text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.logout'),
            handler: () => {
              console.log(this.tag, "LOGOUT");
              this.isAlertShowing = false;
              this.isLogoutOptionClicked = true;
              this.setReaderDisconnected();
            }
          },
          {
            text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.cancel'),
            role: 'cancel',
            handler: () => {
              console.log(this.tag, 'Cancel clicked');
              this.isAlertShowing = false;
            }
          }
        ]
      });
    }
    this.isAlertShowing = true;
    this.alertExitLogOut.present();
  }

  private setReaderDisconnected() {
    this.readerService.disconnect().subscribe(
      (response: any) => {
        console.log(this.tag, response);
        this.closeApp();
      }, (error) => {
        this.closeApp();
      }
    );
  }

  private closeApp() {
    if (this.isLogoutOptionClicked) {
      console.log(this.tag, "logoutOptionIsClicked");
      this.recordEventAndLogout();
    }
    else {
      console.log(this.tag, "logoutOptionNotClicked");
      this._platform.exitApp();
    }
  }

  private recordEventAndLogout() {
    this.vizixEventService.getVizixEventItemBase().then((vizixEvent: VizixEventItem) => {
      vizixEvent.action = VizixEventAction.NONE;
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.AUTHENTICATION;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.activity = VizixEventActivity.LOGOUT;
      this.vizixEventService.recordEvent(vizixEvent).then(() => {
        clearTimeout(this.logoutTimer);
        this.logout();
      });
      this.logoutTimer = setTimeout(() => {
        this.logout();
      }, 1000);
    }, () => {
      this.logout();
    }).catch(() => {
      this.logout();
    });
  }

  private logout() {
    this.vizixService.VizixLogOut().subscribe(() => {
      console.log(this.tag, "LogOut success");
    }, (err) => {
      console.log(this.tag, "Error LogOut", err);
    });
    this.vizixService.clearVizixService();
    this.storage.remove(STORAGE_READER_SOUND_LEVEL).then(() => {
      console.log(this.tag, "Sound reader level Removed");
    }, (err) => {
      console.log(this.tag, "Error removing Sound reader level", err);
    });

    if (!this.isPopActive) {
      this.isPopActive = true;
      this.navCtrl.popToRoot({animate: false}).then(() => {
        this.navCtrl.push(LoginPage);
      });
    }
  }

  /**
   * Init loading
   * @returns {Loading}
   */
  initLoading() {
    return this.loadingCtrl.create({
      content: this.translate.instant('pair_sled.loading')
    });
  }

  ngOnDestroy() {
    // always unsubscribe your subscriptions to prevent leaks
    this.onResumeSubscription.unsubscribe();
  }

  ionViewWillUnload() {
    this.onResumeSubscription.unsubscribe();
  }

  ionViewWillLeave() {
    this.unsubscribeAll();
    // this.cdr.detach()
  }

  onChangeKeyValue(event)
  {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(VALIDATION_INPUT_DEVICE_NAME);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.searchText = event.replace(charPressed, '');
      this.inputTypeScanField.value = this.searchText;
      this.cdr.detectChanges();
    }
    else {
      this.searchText = event;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/device-select/device-select.ts